module.exports = new __parcel__URL__("battlepass_chapter.10b900b4.png").toString();